var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForwardUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2733 15.2121C17.2733 15.6264 17.6091 15.9621 18.0233 15.9621C18.4375 15.9621 18.7733 15.6264 18.7733 15.2121L18.7733 7.01975C18.7733 6.05326 17.9898 5.26975 17.0233 5.26975L8.83095 5.26975C8.41673 5.26975 8.08095 5.60554 8.08095 6.01975C8.08095 6.43397 8.41673 6.76975 8.83095 6.76975L16.2127 6.76975L5.82574 17.1567C5.53285 17.4496 5.53285 17.9245 5.82574 18.2173C6.11864 18.5102 6.59351 18.5102 6.8864 18.2173L17.2733 7.83041L17.2733 15.2121Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardUpRight);
export default __webpack_public_path__ + "static/media/arrow_forward_up_right.102e6244a39742d24ed8ef9915077dd0.svg";
export { ForwardRef as ReactComponent };